import { useEffect, useRef, useState } from "react";
import { useHistory } from "react-router-dom";
import { Box, TextField, Button } from "@mui/material";
import { SERVER_URL } from "../app/constant";

export const ForgotPasswordPage = () => {
  const [errorMessage, setErrorMessage] = useState("");
  const [success, setSuccess] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [emailValue, setEmailValue] = useState("");
  const history = useHistory();
  const redirectTimeoutRef = useRef(null);

  useEffect(() => {
    return () => clearTimeout(redirectTimeoutRef.current);
  }, []);

  const onSubmitClicked = async () => {
    setIsSubmitting(true);
    setErrorMessage("");
    try {
      const requestOptions = {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          email: emailValue,
        }),
      };

      const response = await fetch(`${SERVER_URL}/forgot-password`, requestOptions);
      if (!response.ok) {
        throw new Error("We couldn't send a reset link. Please try again.");
      }

      setSuccess(true);
      redirectTimeoutRef.current = setTimeout(() => {
        history.push(
          `/reset-password?email=${encodeURIComponent(emailValue)}`
        );
      }, 3000);
    } catch (e) {
      setErrorMessage(e.message);
    } finally {
      setIsSubmitting(false);
    }
  };

  return success ? (
    <Box
      component="main"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <h1 style={{ color: "#3366BB" }}>Success</h1>
      <p>Check your email for a reset link</p>
    </Box>
  ) : (
    <Box
      component="main"
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <h1 style={{ color: "#3366BB" }}>Forgot Password</h1>

      <p>Enter your email and we'll send you a reset link</p>
      {errorMessage && <div className="fail" role="alert">{errorMessage}</div>}
      <TextField
        sx={{ width: "300px", mt: 2 }}
        id="forgot-password-email"
        label="Email"
        type="email"
        autoComplete="email"
        value={emailValue}
        onChange={(e) => setEmailValue(e.target.value)}
      />
      <Button
        variant="contained"
        sx={{ width: "300px", mt: 2 }}
        disabled={!emailValue || isSubmitting}
        onClick={onSubmitClicked}
      >
        {isSubmitting ? "Sending..." : "Send Reset Link"}
      </Button>
    </Box>
  );
};
